import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import guide from '../../../public/docs/BitaaGuide.pdf';
import header from '../../../public/icons/howto.jpeg';
import tools1 from '../../../public/icons/howTo1.jpg';
import tools2 from '../../../public/icons/howTo2.jpg';
import tools3 from '../../../public/icons/howTo3.jpg';
import divider from '../../../public/icons/about_divider.png';
import style from './HowTo.css';

class HowTo extends React.Component {
  render() {
    const dividerElement = (
      <div className={style.dividerWrapper}>
        <img src={divider} />
      </div>
    );

    return (
      <div className="container-fluid">
        <div className={cx('row', style.rowContainer)}>
          <div className={style.headerImage}>
            <img src={header} />
          </div>
          <div className={style.topCardsContainer}>
            <div className={cx(style.topCard, style.topCardOne)}>
              <div className={style.topCardTitle}>HOW SHOULD I FOLLOW THIS RESOURCE?</div>
              <div className={style.topCardBody}>
                <p>
                  This resource is a compilation of activities and ideas from
                  teachers at our centres, from books, and found online. It is
                  meant to support educators in thinking of, designing, and
                  implementing activities in the classroom.
                </p>
                <p>
                  It is important to note that this resource is NOT a curriculum.
                  It is NOT required that activities in this compilation be
                  followed exactly. Rather, the goal is to provide a starting
                  point, or ideas when teachers feel stuck or students are
                  uninspired.
                </p>
                <p>
                  The creative partner of this resource, Parkland Players, is a
                  Reggio Emilia Childcare Centre. That means that provocation and
                  child-directed learning are central. Follow children’s interests
                  first and foremost, and use this Activities Resource as a
                  supporting tool. Strive to keep activities open-ended, be
                  flexible with themes and projects, allow for children’s input on
                  how to implement activities and listen to what students need in
                  order to learn.
                </p>
              </div>
            </div>
            <div className={cx(style.topCard, style.topCardTwo)}>
              <div className={style.topCardTitle}>HOW THIS RESOURCE IS FORMATTED?</div>
              <div className={style.topCardBody}>
                <p>
                  This resource is formatted based on monthly and weekly themes
                  following the school year from September to June with additional
                  content for July and August. The resource is divided into
                  months. Each month is further subdivided into weekly themes that
                  relate to the overarching theme for that month or related to
                  special holidays or scheduled events in that month.
                </p>
                <p>
                  The overall goal of the organization of this Activities Resource
                  is to easily flow from one topic to another throughout the
                  school year and to build on previous knowledge in order to
                  approach new topics as the year continues. In each month there
                  are five weeks of material. The weeks do not need to be done in
                  the order they are presented if educators feel as though a
                  different order suits their schedule better. Often there will
                  only be four weeks in the actual month rather than five. In this
                  case educators need not always sacrifice Week 5 they may select
                  whichever week they would prefer not to do, or can combine
                  material from two weeks into one.
                </p>
              </div>
            </div>
          </div>
          {dividerElement}
          <h3 className="text-center">
            <b>TOOLS</b>
          </h3>
          <div className={style.bottomCardsContainer}>
            <div className={cx(style.bottomCard)}>
              <div className={style.bottomCardImageWrapper}><img src={tools1}/></div>
              <div className={style.bottomCardBody}>
                <div className={style.bottomCardTitle}>MONTHLY CALENDAR</div>
                <p>
                  The calendar is meant to provide a quick look at the topics and
                  activities for a given month. This is also the homescreen, you
                  are able to select different views from this screen such as
                  “list view” or “week”.
                </p>
              </div>
            </div>
            <div className={cx(style.bottomCard)}>
              <div className={style.bottomCardImageWrapper}><img src={tools2}/></div>
              <div className={style.bottomCardBody}>
                <div className={style.bottomCardTitle}>LONG TERM PROJECT SHEET</div>
                <p>
                  This document is meant to offer ideas that can be completed on
                  and off continuously throughout the month. The activities are
                  meant to be used in the background to other tasks and often Long
                  Term Projects focus on learning new and interesting skills (ex.
                  knitting), or are meant to provoke thought and creativity
                  regarding a specific theme (ex. design challenges), or they are
                  meant to encourage collaboration and teamwork among children
                  (ex. mural projects).
                </p>
              </div>
            </div>
            <div className={cx(style.bottomCard)}>
              <div className={style.bottomCardImageWrapper}><img src={tools3}/></div>
              <div className={style.bottomCardBody}>
                <div className={style.bottomCardTitle}>ACTIVITY PLANNING SHEETS</div>
                <p>
                  These are the actual activities for each week. They can be
                  accessed by clicking on any given activity in the calendar view.
                  These sheets provide a title for the activity, the domain of
                  learning it applies to (explanation of domains of learning to
                  follow) and an objective for learning for that individual
                  activity. Most of the time, any paper materials required for the
                  activity will be immediately following the instructions (ex. A
                  template or wordsearch). There will also often be a picture from
                  the source site to give an idea of what the finished product
                  looks like.
                </p>
              </div>
            </div>
          </div>
          {dividerElement}
          <div className={cx('text-center', style.gettingStarted)}>
            Download the “Getting Started” guide here:{' '}
            <a target="_blank" href={guide} className={style.gettingStartedLink}>“Getting Started”</a>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(style)(HowTo);



// WEBPACK FOOTER //
// ./src/routes/howto/HowTo.js